<template>
  <span class="setting-trigger" @click="open" title="主题设置">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  </span>

  <el-drawer title="主题设置" v-model="visible" direction="rtl" size="300px">
    <div class="setting-body">
      <!-- 主题色 -->
      <div class="block">
        <div class="block-title">系统主题色</div>
        <div class="color-list">
          <span v-for="c in colors" :key="c" class="color-dot"
            :class="{ active: primaryColor === c }"
            :style="{ background: c }"
            @click="onColor(c)">
            <i v-if="primaryColor === c" class="el-icon-check" style="color:#fff;font-size:12px;font-weight:bold;"></i>
          </span>
        </div>
      </div>

      <!-- 暗黑模式 -->
      <div class="block">
        <div class="block-title">暗黑模式</div>
        <div class="row">
          <span>启用暗黑模式</span>
          <el-switch v-model="isDark" @change="onDark" />
        </div>
      </div>

      <!-- 界面显示 -->
      <div class="block">
        <div class="block-title">界面显示</div>
        <div class="row">
          <span>显示标签页</span>
          <el-switch v-model="showTagsView" @change="onTags" />
        </div>
        <div class="row">
          <span>显示侧边栏 Logo</span>
          <el-switch v-model="showLogo" @change="onLogo" />
        </div>
        <div class="row">
          <span>显示页脚</span>
          <el-switch v-model="showFooter" @change="onFooter" />
        </div>
      </div>

      <!-- 辅助功能 -->
      <div class="block">
        <div class="block-title">辅助功能</div>
        <div class="row">
          <span>灰色模式</span>
          <el-switch v-model="greyMode" @change="onGrey" />
        </div>
        <div class="row">
          <span>色弱模式</span>
          <el-switch v-model="colorWeak" @change="onWeak" />
        </div>
      </div>

      <!-- 重置 -->
      <div class="block">
        <el-button type="warning" plain style="width:100%;" @click="reset">恢复默认</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SettingDrawer',
  data() {
    return {
      visible: false,
      colors: [
        '#4f7afd', '#f05b72', '#426ab3', '#faa755',
        '#65c294', '#c88400', '#9b95c9', '#002FA7',
        '#FF6347', '#B05923', '#2e3a1f'
      ]
    }
  },
  computed: {
    ...mapState('app', [
      'isDark', 'primaryColor', 'greyMode', 'colorWeak',
      'showTagsView', 'showLogo', 'showFooter'
    ])
  },
  methods: {
    open() { this.visible = true },
    onDark(v) { this.$store.commit('app/SET_DARK', v) },
    onColor(c) {
      this.$store.dispatch('app/setColor', c)
      // 同步旧的 setColor.vue 系统
      const colorMap = {
        '#4f7afd': 'bg_4f7afd',
        '#f05b72': 'bg_f05b72',
        '#426ab3': 'bg_426ab3',
        '#faa755': 'bg_faa755',
        '#65c294': 'bg_65c294',
        '#c88400': 'bg_c88400',
        '#9b95c9': 'bg_9b95c9',
        '#002FA7': 'bg_002FA7',
        '#FF6347': 'bg_FF6347',
        '#B05923': 'bg_B05923',
        '#2e3a1f': 'bg_2e3a1f',
      }
      const cls = colorMap[c] || 'bg_4f7afd'
      localStorage.setItem('theme', cls)
      localStorage.setItem('theme2', cls + '2')
      localStorage.setItem('theme3', cls + '3')
      localStorage.setItem('theme4', cls + '4')
      localStorage.setItem('theme5', cls + '5')
      localStorage.setItem('theme6', cls + '6')
      localStorage.setItem('theme7', cls + '7')
      localStorage.setItem('theme8', c)
      location.reload()
    },
    onTags(v) { this.$store.commit('app/SET_TAGS', v) },
    onLogo(v) { this.$store.commit('app/SET_LOGO', v) },
    onFooter(v) { this.$store.commit('app/SET_FOOTER', v) },
    onGrey(v) { this.$store.commit('app/SET_GREY', v) },
    onWeak(v) { this.$store.commit('app/SET_WEAK', v) },
    reset() {
      localStorage.clear()
      location.reload()
    }
  }
}
</script>

<style scoped>
.setting-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  cursor: pointer;
  vertical-align: middle;
  transition: background 0.2s;
}
.setting-trigger:hover {
  background: rgba(0,0,0,0.05);
}
.dark .setting-trigger:hover {
  background: rgba(255,255,255,0.1);
}

.setting-body { padding: 0 10px; }

.block { margin-bottom: 28px; }
.block-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #303133);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color-lighter, #ebeef5);
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-regular, #606266);
}
.color-list { display: flex; flex-wrap: wrap; gap: 10px; }
.color-dot {
  width: 30px; height: 30px; border-radius: 6px;
  cursor: pointer; display: flex; align-items: center;
  justify-content: center; transition: transform 0.2s;
}
.color-dot:hover { transform: scale(1.2); }
.color-dot.active {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--el-color-primary, #4f7afd);
}
</style>
